import React from 'react';
import InsurancePaymentDisclaimer from './InsurancePaymentDisclaimer';

/**
 * Gets the description for a requisition price.
 *
 * @param gearOrder The current gear order
 * @param billingOptionName the billing option name
 * @param requisitionPrice the requisition price object
 * @param doNotQuotePrices {boolean} A flag indicating if prices should not be displayed
 */
export default function PriceDescription({ gearOrder, billingOptionName, requisitionPrice, doNotQuotePrices }) {
	let description = null;

	if (!requisitionPrice) {
		return null;
	}
	if (requisitionPrice?.error) {
		description = (
			<div>
				<p className="text-warning">
					<strong>
						Error <i class="fa padding-x-xs fa-exclamation-triangle"></i>
					</strong>
				</p>
				<p>We apologize, but we were not able to determine pricing information at this time.</p>
			</div>
		);
	} else if (billingOptionName === process.env.REACT_APP_BILLING_MEDICARE_VALUE) {
		const medicarePrice = requisitionPrice?.medicarePrice ?? 0;
		const tricarePrice = requisitionPrice?.tricarePrice ?? 0;
		if (medicarePrice !== tricarePrice) {
			description = (
				<div>
					<p>
						<strong>Medicare or Tricare</strong>
					</p>
					<p>
						If the patient is covered by <strong>Medicare</strong>, the amount due today is{' '}
						<strong>
							${parseFloat(Math.round(requisitionPrice.medicarePrice * 100) / 100).toFixed(2)}
						</strong>
						.
					</p>
					<p>
						If the patient is covered by <strong>Tricare</strong>, the amount due today is{' '}
						<strong>${parseFloat(Math.round(requisitionPrice.tricarePrice * 100) / 100).toFixed(2)}</strong>
						.
					</p>
				</div>
			);
		}
	} else if (billingOptionName === process.env.REACT_APP_BILLING_INSURANCE_VALUE) {
		description = (
			<InsurancePaymentDisclaimer
				gearOrder={gearOrder}
				prices={[requisitionPrice]}
				doNotQuotePrices={doNotQuotePrices}
			/>
		);
	}

	return description;
}
